import { Prompt, PromptType } from "@/models";

/**
 * Whether a participant form value leaves its prompt unanswered.
 *
 * A real 0 (or "0") is an answer: a slider or numerical input set to 0 is
 * not empty. undefined/null/"" are missing. An empty array is missing too,
 * EXCEPT for a Multiple Select, where `[]` is the answer "none of these":
 * the participant may tick nothing, and the submit still saves one
 * is_selected=false row per option, so "has submitted on this page" display
 * rules still fire.
 */
export const isPromptUnanswered = (
    prompt: Pick<Prompt, "prompt_type">,
    value: unknown,
): boolean => {
    if (value === undefined || value === null || value === "") {
        return true;
    }
    if (Array.isArray(value) && value.length === 0) {
        return prompt.prompt_type !== PromptType["Multiple Select"];
    }
    return false;
};
